import React from 'react';
import ContactForm from './ContactForm';

const ContactUs = ({ title, introText, phoneNumber, email, address }) => {
  return (
    <section id="contact" className="py-16 bg-brand-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-brand-900 sm:text-5xl">
            {title || 'Contact Us'}
          </h2>
          <div className="w-24 h-1 bg-accent-500 mx-auto mt-4 mb-8"></div>
          <p className="max-w-3xl mx-auto text-xl text-neutral-700">
            {introText || 'Have questions or want to learn more about Baniuaga Group? We\'d love to hear from you.'}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div className="glass-card p-10 rounded-xl flex flex-col h-full relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-2 bg-brand-600"></div>
            <h3 className="text-2xl font-bold text-brand-800 mb-8">Get in Touch</h3>
            
            <div className="w-full h-72 mb-8 rounded-lg overflow-hidden shadow-md">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3155.5991206440904!2d125.54779236124487!3d-8.553749247185653!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2d01dd71e6315739%3A0x9214346c423b8c29!2sBANIUAGA%20GROUP!5e0!3m2!1sen!2stl!4v1744278205097!5m2!1sen!2stl" 
                width="100%" 
                height="100%" 
                style={{ border: 0 }} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Baniuaga Group Office Location"
                className="rounded-lg"
              ></iframe>
            </div>
            
            <div className="mt-auto border-t border-neutral-100 pt-8">
              <div className="grid grid-cols-1 gap-6">
                <div className="flex items-start">
                  <div className="flex-shrink-0 bg-brand-100 p-3 rounded-full text-brand-600">
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <div className="ml-4">
                    <p className="text-neutral-500 text-sm uppercase tracking-wider font-medium">Phone</p>
                    <p className="text-brand-900 font-medium text-lg">{phoneNumber || '+1 (555) 123-4567'}</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="flex-shrink-0 bg-brand-100 p-3 rounded-full text-brand-600">
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div className="ml-4">
                    <p className="text-neutral-500 text-sm uppercase tracking-wider font-medium">Email</p>
                    <p className="text-brand-900 font-medium text-lg break-words">{email || 'info@baniuagagroup.com'}</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="flex-shrink-0 bg-brand-100 p-3 rounded-full text-brand-600">
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <div className="ml-4">
                    <p className="text-neutral-500 text-sm uppercase tracking-wider font-medium">Address</p>
                    <p className="text-brand-900 font-medium text-lg">{address || '123 Business Avenue, Suite 400, Corporate City, BZ 12345'}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="glass-card p-10 rounded-xl flex flex-col h-full relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-2 bg-accent-500"></div>
            <h3 className="text-2xl font-bold text-brand-800 mb-8">Send Us a Message</h3>
            <div className="flex-grow">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;